import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Card,
  IconButton,
  Modal,
  Box,
  TableContainer,
  Paper,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomDatagrid from "../../../../components/datagrid";
import moment from "moment";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "80%",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function OrdersList({
  client,
  onClose,
  subscriptionData,
  rowCountSub,
  setRowCountSub,
  paginationModelSub,
  setPaginationModelSub,
}) {
  const navigate = useNavigate();
  const orders = [
    {
      id: 1,
      product: "PBA",
      business: "Business 1",
      status: "Active",
      subscriptionId: "154789/459",
      purchasedOn: "20 Aug 2024",
      expiry: "19 Sep 2024",
      plan: "Starter",
    },
  ];
  const handleGrade = () => {
    navigate("/products/plan");
  };

  const handleRenew = () => {
    navigate("/products/pricing");
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "Active":
        return (
          <Chip
            variant="outlined"
            label="Active"
            color="success"
            size="small"
          />
        );
      case "Inactive":
        return (
          <Chip
            variant="outlined"
            label="Inactive"
            color="warning"
            size="small"
          />
        );
      case "Expired":
        return (
          <Chip variant="outlined" label="Expired" color="error" size="small" />
        );
      default:
        return <Chip variant="outlined" label={status} size="small" />;
    }
  };

  const clientListRows = Array.isArray(subscriptionData.data)
    ? subscriptionData.data.map((data, index) => {
        return {
          id: index + 1,
          sno_id: index + 1,
          productName: data?.productPlanDetails?.product?.name || "N/A",
          businessName: data?.userDetails?.organization_name || "N/A",
          subscriptionID: data?.subscription_code || "N/A",
          subscriptionPlan:
            data?.productPlanDetails?.product_plan_name || "N/A",
          purchasedOn: data?.paymentReceipt?.payment_date,
          expiry: data?.expiry_date,
          status: data?.subscription_status,
        };
      })
    : [];

  const columns = [
    {
      field: "sno_id",
      headerName: "S.No",
      width: 100,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "productName",
      headerName: "Product Name",
      width: 150,
      headerAlign: "left",
      align: "left",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "businessName",
      headerName: "Business Name",
      width: 250,
      headerAlign: "left",
      align: "left",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "subscriptionID",
      headerName: "Subscription ID",
      width: 150,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "subscriptionPlan",
      headerName: "Subscription Plan",
      width: 200,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "purchasedOn",
      headerName: "Purchased On",
      width: 150,
      headerAlign: "left",
      align: "left",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        moment(params.row.purchasedOn).format("DD/MM/YYYY"),
    },
    {
      field: "expiry",
      headerName: "Expiry",
      width: 150,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => moment(params.row.expiry).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <Chip
          label={
            params.row.status?.charAt(0).toUpperCase() +
            params.row.status?.slice(1)
          }
          color={
            params.row.status === "Active" || params.row.status === "active"
              ? "success"
              : "error"
          }
          variant="outlined"
        />
      ),
    },
  ];

  return (
    <Modal
      open={Boolean(client)}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <Typography variant="h6">Subscription Details</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 4,
            right: 8,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <TableContainer
          sx={{
            overflowX: "auto",
            maxWidth: "100%",
          }}
        >
          {clientListRows.length === 0 ? (
            <Typography variant="h6" align="center" sx={{ padding: 2 }}>
              No Data Found
            </Typography>
          ) : (
            <CustomDatagrid
              rows={clientListRows}
              columns={columns}
              getRowId={(row) => row.id}
              paginationModel={paginationModelSub}
              onPaginationModelChange={setPaginationModelSub}
              rowCount={rowCountSub}
              disableSelectionOnClick={true}
              checkboxSelection={false}
            />
          )}
        </TableContainer>
      </Box>
    </Modal>
  );
}

export default OrdersList;
